import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './routes';
import { LocaleProvider } from './contexts/LocaleContext';
import { ErrorBoundary, ErrorBoundaryWithIntl } from './components/ErrorBoundary';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LocaleProvider>
        <ErrorBoundaryWithIntl>
          <Routes />
        </ErrorBoundaryWithIntl>
      </LocaleProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
